/**
 * Placeholder YouTube URL для `<VideoButton>` на Экране 2.10.1 «Что улучшить?»
 * (CLAUDE.md §16.4 — на entry-экранах функций видео-инструкция первым элементом
 * контента, B-008 pattern).
 *
 * Реальный URL подставит продакт когда видео-инструкция для Block 10 будет готова.
 */
// TODO(product): replace with real YouTube URL when видео-инструкция для Block 10 ready.
export const FEEDBACK_VIDEO_URL = 'https://www.youtube.com/watch?v=PLACEHOLDER_BLOCK_10';
